import { MenuProps } from 'antd/es/menu';
import { Link } from 'react-router-dom';
import {
  LayoutDashboard,
  BriefcaseBusiness,
  User,
  BookOpen,
  StickyNote,
  ChartColumnDecreasing,
  Trophy,
  Calendar,
  LucideBriefcaseBusiness,
  ScrollText,
  FolderOpen,
} from 'lucide-react';
type MenuItem = Required<MenuProps>['items'][number];
/* Admin ICLD menu */

export const adminICDLMenu: (translate: any) => MenuItem[] = (translate) => [
  {
    label: <Link to={'dashboard'}>{translate('dashboard.dashboard')}</Link>,
    key: 'dashboard',
    icon: <LayoutDashboard className='text-primary' />,
  },
  {
    label: <Link to={'calendar'}>{translate('common.calendar')}</Link>,
    key: 'calendar',
    icon: <Calendar className='text-primary' />,
  },
  {
    label: <Link to={'school'}>{translate('school.school')}</Link>,
    key: 'school',
    icon: <BriefcaseBusiness className='text-primary' />,
  },
  {
    label: <Link to={'class'}>{translate('class.class')}</Link>,
    key: 'class',
    icon: <BookOpen className='text-primary' />,
  },
  // {
  //   label: <Link to={'student'}>{translate('student.student')}</Link>,
  //   key: 'student',
  //   icon: <User />,
  // },
  // {
  //   label: (
  //     <Link to={'distribution-evaluation'}>
  //       {translate('common.distribute-material')}
  //     </Link>
  //   ),
  //   key: 'distribution-evaluation',
  //   icon: <ScrollText />,
  // },
  {
    label: translate('rolemenu.teacher.material'),
    key: 'material',
    icon: <FolderOpen />,
    children: [
      {
        label: <Link to={'modules'}>{translate('common.course')}</Link>,
        key: 'modules',
      },
      // {
      //   key: 'questions',
      //   label: (
      //     <Link to={'learning-material'}>
      //       {translate('bank_question.bank_question')}
      //     </Link>
      //   ),
      // },
    ],
  },
  {
    label: translate('report.report'),
    key: 'report',
    icon: <ChartColumnDecreasing />,
    children: [
      {
        label: <Link to={'reporting_practice'}>{translate('common.report_practice')}</Link>,
        key: 'reporting_practice',
      },
      {
        label: <Link to={'reporting_exams'}>{translate('common.report_exam')}</Link>,
        key: 'reporting_exams',
      }
    ]

  },
  {
    label: translate('common.management'),
    key: 'manage',
    icon: <StickyNote />,
    children: [
      {
        label: <Link to={'role'}>{translate('permission.role_and_permission')}</Link>,
        key: 'role',
      },
      {
        label: <Link to={'account'}>{translate('account.account')}</Link>,
        key: 'account',
      },
      {
        label: <Link to={'task-jobs'}>{translate('task_jobs.task_jobs')}</Link>,
        key: 'task-jobs',
      },
      {
        label: <Link to={'grade'}>{translate('grade.grade')}</Link>,
        key: 'gradeclass',
      },
      {
        label: <Link to={'partners'}>{translate('partner.partner')}</Link>,
        key: 'partners',
      },
      {
        label: (
          <Link to={'zoom-account'}>
            {translate('zoom_account.zoom_account')}
          </Link>
        ),
        key: 'zoom-account',
      },
    ],
  },
];

/* Admin school menu */
export const adminSchoolMenu: (translate: any) => MenuItem[] = (translate) => [
  {
    label: <Link to={'dashboard'}>{translate('dashboard.dashboard')}</Link>,
    key: 'dashboard',
    icon: <LayoutDashboard className='text-primary' />,
  },
  {
    label: <Link to={'calendar'}>{translate('common.calendar')}</Link>,
    key: 'calendar',
    icon: <Calendar className='text-primary' />,
  },
  // {
  //   label: <Link to={'school'}>{translate('school.school')}</Link>,
  //   key: 'school',
  //   icon: <BriefcaseBusiness className='text-primary' />,
  // },
  {
    label: <Link to={'class'}>{translate('class.class')}</Link>,
    key: 'class',
    icon: <BookOpen className='text-primary' />,
  },
  // {
  //   label: <Link to={'student'}>{translate('student.student')}</Link>,
  //   key: 'student',
  //   icon: <User />,
  // },
  {
    label: <Link to={'distribution-evaluation'}>{translate('common.distribute-material')}</Link>,
    key: 'distribution-evaluation',
    icon: <ScrollText />,
  },
  {
    label: translate('report.report'),
    key: 'report',
    icon: <ChartColumnDecreasing />,
    children: [
      {
        label: <Link to={'reporting_practice'}>{translate('common.report_practice')}</Link>,
        key: 'reporting_practice',
      },
      {
        label: <Link to={'reporting_exams'}>{translate('common.report_exam')}</Link>,
        key: 'reporting_exams',
      }
    ]

  },
  {
    label: translate('rolemenu.teacher.material'),
    key: 'material',
    icon: <FolderOpen />,
    children: [
      {
        label: <Link to={'modules'}>{translate('common.course')}</Link>,
        key: 'modules',
      },
      // {
      //   key: 'questions',
      //   label: (
      //     <Link to={'learning-material'}>{translate('bank_question.bank_question')}</Link>
      //   ),
      // },
    ],
  },
  {
    label: translate('common.management'),
    key: 'manage',
    icon: <StickyNote />,
    children: [
      // {
      //   label: <Link to={'group-permissions'}>{translate('permission.group_permission')}</Link>,
      //   key: 'group-permissions',
      // },
      {
        label: <Link to={'account'}>{translate('account.account')}</Link>,
        key: 'account',
      },
      {
        label: <Link to={'task-jobs'}>{translate('task_jobs.task_jobs')}</Link>,
        key: 'task-jobs',
      },
      // {
      //   label: <Link to={'grade'}>{translate('grade.grade')}</Link>,
      //   key: 'gradeclass'
      // },
    ],
  },
];
/* Teacher menu */
export const teacherMenu: (translate: any) => MenuItem[] = (translate: any) => [
  {
    label: <Link to={'dashboard'}>{translate('rolemenu.teacher.home')}</Link>,
    key: 'dashboard',
    icon: <LayoutDashboard className='text-primary' />,
  },
  {
    label: <Link to={'calendar'}>{translate('common.calendar')}</Link>,
    key: 'calendar',
    icon: <Calendar className='text-primary' />,
  },
  {
    label: (
      <Link to={'checktest'}>{translate('rolemenu.teacher.checktest')}</Link>
    ),
    key: 'checktest',
    icon: <LucideBriefcaseBusiness className='text-primary' />,
  },
  {
    label: (
      <span style={{ fontWeight: 700, color: '#000' }}>
        {translate('report.report')}
      </span>
    ),
    key: 'report',
    icon: <ChartColumnDecreasing />,
    children: [
      {
        label: (
          <Link to={'statistic'}>
            {translate('rolemenu.teacher.statistic')}
          </Link>
        ),
        key: 'statistic',
      },
      {
        label: (
          <Link to={'detail_report'}>
            {translate('rolemenu.teacher.detail_report')}
          </Link>
        ),
        key: 'detail_report',
      },
    ],
  },
];
/* Student menu */
export const studentMenu: (translate: any) => MenuItem[] = (translate: any) => [
  {
    label: <Link to={'dashboard'}>Home</Link>,
    key: 'dashboard',
    icon: <LayoutDashboard className='text-primary' />,
  },
  {
    label: <Link to={'calendar'}>{translate('common.calendar')}</Link>,
    key: 'calendar',
    icon: <Calendar className='text-primary' />,
  },
  {
    label: <Link to={'class'}>Lớp học</Link>,
    key: 'class',
    icon: <LayoutDashboard className='text-primary' />,
    children: [
      {
        label: <Link to={'lessons'}>Bài học</Link>,
        key: 'lessons',
      },
      {
        label: <Link to={'grade'}>Bài tập</Link>,
        key: 'gradeclass',
      },
      {
        label: <Link to={'modules'}>Bài kiểm tra</Link>,
        key: 'modules',
      },
    ],
  },
  {
    label: <Link to={'practice'}>Luyện thi</Link>,
    key: 'practice',
    icon: <BriefcaseBusiness className='text-primary' />,
  },
  {
    label: <Link to={'examtest/overview'}>Thi thử</Link>,
    key: 'preparation',
    icon: <Trophy className='text-primary' />,
  },
];
